import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=f1ce8048&scoped=true"
import script from "./pending.vue?vue&type=script&lang=ts"
export * from "./pending.vue?vue&type=script&lang=ts"
import style0 from "./pending.vue?vue&type=style&index=0&id=f1ce8048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ce8048",
  null
  
)

export default component.exports